import { Box } from '@mui/material'
import React from 'react'
import theme from '../../../theme'
import CloseIcon from '@mui/icons-material/Close'

export interface WizardHeaderProps {
  title: string
  setIsOpen: (isOpen: boolean) => void
}

export const WizardHeader: React.FC<WizardHeaderProps> = ({ title, setIsOpen }): JSX.Element => {
  return (
    <Box
      sx={{
        width: '100%',
        p: theme.spacing(4),
        px: theme.spacing(6),
        flexDirection: 'row',
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: theme.typography.h6.fontSize,
        fontFamily: theme.typography.fontFamily,
        fontWeight: 'bold'
      }}
    >
      <Box sx={{ flex: 1 }}>
        {title}
      </Box>
      <Box
        sx={{
          cursor: 'pointer',
          '&:hover': { opacity: 0.3 },
          transition: 'opacity 0.1s ease-in-out'
        }}
        onClick={() => { setIsOpen(false) }}
      >
          <CloseIcon />
      </Box>
    </Box>
  )
}
